import { render, staticRenderFns } from "./communicationDashboardPrintGenerator.vue?vue&type=template&id=6fc57beb&scoped=true"
import script from "./communicationDashboardPrintGenerator.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPrintGenerator.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardPrintGenerator.vue?vue&type=style&index=0&id=6fc57beb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc57beb",
  null
  
)

export default component.exports